import { Feature, FeatureCollection, MultiPolygon, Polygon } from "geojson";
import buffer from "@turf/buffer";
import { VelavuFloorGeometry } from "velavu-js-api";

/**
 * Converts an array of drawn walls to geometry suitable for rendering on the map
 */
export function velavuFloorGeometryToMapGeoJSON(
	geometry: VelavuFloorGeometry,
): FeatureCollection<Polygon | MultiPolygon> {
	//Add thickness to the walls
	return buffer(geometry.walls, 5, {
		units: "centimeters",
	})!;
}

/**
 * Converts drawn floor wall outlines to filled polygons suitable for rendering on the map.
 */
export function velavuFloorGeometryToFilledMapGeoJSON(
	geometry: VelavuFloorGeometry,
): FeatureCollection<Polygon> {
	const features = geometry.walls.features
		.map((feature): Feature<Polygon> | undefined => {
			const coordinates = feature.geometry.coordinates;

			//Ignore walls with fewer than 3 coordinates
			if (coordinates.length < 3) {
				return undefined;
			}

			//Connect the last coordinate back to the first coordinate to form a closed polygon
			const firstCoordinate = coordinates[0];
			const closedCoordinates = [...coordinates, firstCoordinate];

			return {
				type: "Feature",
				properties: {},
				geometry: {
					type: "Polygon",
					coordinates: [closedCoordinates],
				},
			};
		})
		.filter((feature) => {
			return feature !== undefined;
		});

	return {
		type: "FeatureCollection",
		features,
	};
}

/**
 * Converts an array of drawn walls to Velavu floor geometry
 */
export function floorWallsToVelavuFloorGeometry(
	walls: [number, number][][],
): VelavuFloorGeometry {
	return {
		walls: {
			type: "FeatureCollection",
			features: walls.map((points) => ({
				type: "Feature",
				properties: {},
				geometry: {
					type: "LineString",
					coordinates: points,
				},
			})),
		},
	};
}

/**
 * Converts a Velavu floor geometry to an array of walls
 */
export function velavuFloorGeometryToFloorWalls(
	geometry: VelavuFloorGeometry,
): [number, number][][] {
	return geometry.walls.features.map((feature) => {
		return feature.geometry.coordinates.map((coordinate) => {
			return [coordinate[0], coordinate[1]];
		});
	});
}
